import { FormControl, MenuItem, Typography, Select } from '@material-ui/core'
import React from 'react'

import { trackKinds } from 'constants/twilio'
import { logger } from 'utils/logger'

import { Container } from './styles'

import useMediaStreamTrack from '../../../../hooks/useMediaStreamTrack/useMediaStreamTrack'
import useVideoContext from '../../../../hooks/useVideoContext/useVideoContext'
import { useAudioInputDevices } from '../deviceHooks/deviceHooks'
import LocalAudioLevelIndicator from '../LocalAudioLevelIndicator/LocalAudioLevelIndicator'

export default function AudioInputList() {
    const audioInputDevices = useAudioInputDevices()
    const { audioTrack } = useVideoContext()

    useMediaStreamTrack(audioTrack)
    const localAudioInputDeviceId =
        audioTrack && audioTrack.mediaStreamTrack.getSettings().deviceId

    async function replaceTrack(newDeviceId) {
        if (audioTrack && newDeviceId) {
            try {
                await audioTrack.restart({
                    deviceId: { exact: newDeviceId },
                })
            } catch (err) {
                logger.error(`error in switching audio input :- ${err}`)
            }
        }
    }

    console.count('AudioInputList Component')

    return (
        <Container>
            <div className="inputSelect">
                {audioInputDevices.length > 1 ? (
                    <FormControl fullWidth>
                        <Typography variant="h6">Audio Input:</Typography>
                        <Select
                            onChange={e => replaceTrack(e.target.value)}
                            value={localAudioInputDeviceId || ''}
                        >
                            {audioInputDevices.map(device => {
                                return (
                                    <MenuItem
                                        value={device.deviceId}
                                        key={device.deviceId}
                                    >
                                        {device.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                ) : (
                    <>
                        <Typography variant="h6">Audio Input:</Typography>
                        <Typography>
                            {(audioTrack &&
                                audioTrack.mediaStreamTrack.label) ||
                                'No Local Audio'}
                        </Typography>
                    </>
                )}
            </div>
            <LocalAudioLevelIndicator width={15} />
        </Container>
    )
}
